<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="advancedFilterReminderCreatedByOptions"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
></pp-advanced-filter-option-select>
